module.exports = __webpack_public_path__ + "img/2x.6b7b394.jpg";